import React, { useEffect, useState } from 'react';
import { TagPicker, Checkbox } from 'rsuite';
import '../inputBox.css';

function TagSelectPicker2(props) {
  const {
    placeholder,
    label,
    selectStyle,
    msgStyle,
    labelStyle,
    showMSG,
    retuired,
    data = [],
    onSelect,
    valueKey,
    onSearch,
    labelKey,
    defaultValue,
    style,
    defaultData,
    value = [],
    container,
    onClean,
    disabled,
    renderMenuItem,
  } = props;

  const [selectAll, setSelectAll] = useState(false);
  let timeout = null;

  useEffect(() => {
    if (defaultData && typeof defaultData === 'object') {
      const exists = data.find((item) => item[valueKey] === defaultData[valueKey]);
      if (!exists) {
        data.unshift(defaultData);
      }
    }
  }, [defaultData]);

  useEffect(() => {
    const allValues = data.map((item) => item[valueKey]);
    setSelectAll(value?.length && value.length === allValues.length);
  }, [value, data]);

  const handleSelectValue = (arr) => {
    const selectedData = [];
    const selectedValues = [];
    const selectedTitle = [];

    data.forEach((item) => {
      if (arr?.includes(item[valueKey])) {
        selectedData.push(item);
        selectedValues.push(item[valueKey]);
        selectedTitle.push(item[labelKey]);
      }
    });

    onSelect(selectedValues, selectedTitle, selectedData);
  };

  const handleSelectAllToggle = () => {
    const allValues = data.map((item) => item[valueKey]);
    if (selectAll) {
      handleSelectValue([]);
    } else {
      handleSelectValue(allValues);
    }
    setSelectAll(!selectAll);
  };

  return (
    <div>
      {label && (
        <label className='inputlabel' style={labelStyle}>
          {retuired && <span className='requiredInput'> * </span>} {label}
        </label>
      )}

      <TagPicker
        disabled={disabled || false}
        container={container}
        data={data}
        value={value}
        valueKey={valueKey}
        labelKey={labelKey}
        defaultValue={defaultValue}
        onClean={() => {
          onClean ? onClean() : onSelect && handleSelectValue([]);
        }}
        onChange={handleSelectValue}
        onSearch={(str) => {
          if (typeof onSearch === 'function') {
            if (str?.trim()?.length > 2) {
              if (timeout) clearTimeout(timeout);
              timeout = setTimeout(() => onSearch(str), 300);
            } else {
              onSearch('');
            }
          }
        }}
        style={{ ...style, ...selectStyle }}
        placeholder={placeholder}
        placement='autoVerticalStart'
        renderMenuItem={renderMenuItem}
        renderMenu={(menu) => (
          <>
            {data.length > 0 && (
              <div style={{ padding: '8px 12px', borderBottom: '1px solid #ddd' }}>
                <Checkbox checked={selectAll} indeterminate={value.length > 0 && value.length < data.length} onChange={handleSelectAllToggle}>
                  Select All
                </Checkbox>
              </div>
            )}
            {menu}
          </>
        )}
      />

      {showMSG && (
        <div className='inputMsg' style={msgStyle}>
          {showMSG}
        </div>
      )}
    </div>
  );
}

TagSelectPicker2.defaultProps = {
  data: [],
  valueKey: 'id',
  labelKey: 'title',
  style: { width: '100%' },
  msgStyle: { color: 'red' },
};

export default TagSelectPicker2;
